import React from "react";

const DisplacementContent = ({ displacements, isUpdate = false }) => {
    if (!displacements) return null;

    const list = Array.isArray(displacements) ? displacements : Object.values(displacements);
    if (!list.length) return null;

    const rows = list.flatMap((element, index) => {
        const data = isUpdate ? (element?.new ?? element?.old ?? {}) : element;
        const keys = Object.keys(data);

        return keys.map((key, i) => (
            <tr key={`${index}-${i}`} className={"text-left"}>
                <td style={{width: "30%"}}>{key}</td>
                <td className={"transform translate-x-[5px]"} style={{width: isUpdate ? "35%" : "70%"}}>
                    {isUpdate ? element?.new?.[key] ?? "" : data[key]}
                </td>

                {isUpdate && (
                    <td className={"transform translate-x-[8px]"} style={{width: "35%"}}>
                        {element?.old?.[key] ?? ""}
                    </td>
                )}
            </tr>
        ));
    });

    return (
        <tr className="bg-white displacement-content-table">
            <td colSpan={3} className={'transform -translate-x-[8px]'}>
                <table className="w-full">
                    <thead>
                        <tr className="text-left">
                            <th colSpan={3}>Deslocamento</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default DisplacementContent;